import { axios } from 'lib/axios';

export const verifyEmailOTPSetup = async (data) => {
  return await axios.patch('/user/emailOTPLogin/verifySetup', data);
};
